__turbopack_context__.v({
  "root": "PlasmicTableTh-module__h2sbla__root",
  "slotTargetChildren": "PlasmicTableTh-module__h2sbla__slotTargetChildren",
});
